import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css',
})
export class AboutUsComponent {
  constructor(title: Title, meta: Meta) {
    title.setTitle('About Us');
    meta.addTags([
      {
        name: 'description',
        content: 'Learn more about us.',
      },
      {
        name: 'keywords',
        content: 'Pixel Pro, About, Restaurant System, POS',
      },
    ]);
  }
}
